'use strict';

module.exports = require('./lib/core.js')
require('./lib/done.js')
require('./lib/es6-extensions.js')
require('./lib/node-extensions.js')


/*****************
 ** WEBPACK FOOTER
 ** ../~/promise/index.js
 ** module id = 1076
 ** module chunks = 3
 **/